import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web';

class BtnPrimary extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit"
    }

    this.className = this.className.bind(this)
  }

  componentDidUpdate() {
    if(this.props.loading) {
      lottie.loadAnimation({
        container: document.getElementById(`loader`),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        name: `loader`,
        path: this.props.loaderLottie,
      })
    } else {
      lottie.destroy('loader')
    }
  }

  buttonText() {
    if(!this.props.loading) {
      return this.props.buttonText
    }
    else return null
  }

  componentWillUnmount() {
    lottie.stop('loader')
  }

  className() {
    if(this.props.alert) {
      return "button_primary_alert"
    } else {
      return "button_primary"
    }
  }

  render() {
      return(
        <button
          style={{width: (this.props.fullWidth === true ? "100%" : 'auto')}}
          className={this.className()}
          onClick={() => this.props.onClick()}
          id="loader" style={{marginTop: 24}}>
            {this.buttonText()}
        </button>)
  }
}

export default BtnPrimary;
